import { useState } from 'react';
import styled from 'styled-components';
import { Flex, Text } from 'rebass/styled-components';
import { Field } from 'formik';

const InputContainer = styled(Flex)`
  flex-direction: column;
  position: relative;
opacity: ${({ isDisabled }: { isDisabled?: boolean }) => !!isDisabled ? 0.75 : 1};
  & > label {
    position: absolute;
    pointer-events: none;
    transform: translate(0, 19px) scale(1);
    transform-origin: top left;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    color: #6f81a5;
    font-size: 16px;
    line-height: 1;
    left: 16px;
  }

  .filled {
    transform: translate(-3px, 6px) scale(0.8);
  }
  
  &:focus-within > label {
    transform: translate(-3px, 6px) scale(0.8);
    color: #425d93;
  }
`

export const StyledInputArea = styled.textarea`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  flex: 1 0 auto;
  background: ${(props: any) => (props.disabled ? props.theme.bg.wash : props.theme.bg.default)};
  font-weight: 400;
  font-size: 16px;
  border: 1px solid
    ${(props: any) => (props.disabled ? props.theme.bg.border : props.isAsyncMode ? '#d7d7d7' : props.theme.bg.inactive)};
  border-radius: 10px;
  padding: 18px 12px;
  box-shadow: none;
  transition: border 300ms ease-in-out;

  .filled2 {
    margin-top: 20px;
  }
  &::-webkit-input-placeholder {
    color: ${(props) => props.theme.text.placeholder};
  }
  &:-moz-placeholder {
    color: ${(props) => props.theme.text.placeholder};
  }
  &:-ms-input-placeholder {
    color: ${(props) => props.theme.text.placeholder};
  }
  &:focus {
    border-color: ${(props: any) => (props.isAsyncMode ? '#44a5ff' : props.theme.brand.default)};
    outline: none;
  }
  
  &[type='file'] {
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: hidden;
  }
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  &[type='checkbox'] {
    display: none;
  }
  &[type='checkbox'] + label {
    display: flex;
    border: 1px solid #000;
    width: 18px;
    height: 18px;
    position: relative;
  }
  &[type='checkbox']:checked {
    background: ${(props: any) => (props.disabled ? '#494a4c' : '#344f79')};
  }
  &[type='checkbox']:checked + label {
    background: ${(props: any) => (props.disabled ? '#494a4c' : '#344f79')};
  }
  &[type='checkbox']:checked + label:after {
    content: '✔';
    color: white;
    /* display: inline-block; */
    margin-top: -4px;
    margin-left: 2px;
  }
`;


export const StyledInputFake = styled(Flex)`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  flex: 1 0 auto;
  background: ${props => props.theme.bg.default};
  font-weight: 400;
  font-size: 16px;
  border: 1px solid
    ${props =>
    props.theme.bg.inactive};
  border-radius: 10px;
  padding: 18px 12px;
  box-shadow: none;
  transition: border 300ms ease-in-out;
  height: 56.5px;
  
`;


export const StyledInput = styled.input<any>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  flex: 1 0 auto;
  background: ${props =>
    props.disabled ? props.theme.bg.wash : props.theme.bg.default};
  font-weight: 400;
  font-size: 16px;
  border: 1px solid
    ${props =>
    props.disabled
      ? props.theme.bg.border
      : props.isAsyncMode
        ? '#d7d7d7'
        : props.theme.bg.inactive};
  border-radius: 10px;
  padding: 18px 12px;
  box-shadow: none;
  transition: border 300ms ease-in-out;
  &::disabled {
    opacity: 0.8;
  }
  &::-webkit-input-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:-moz-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:-ms-input-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:focus {
    border-color: ${props =>
    props.isAsyncMode ? '#44a5ff' : props.theme.brand.default};
    outline: none;
  }
  
  &[type='file'] {
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: hidden;
  }

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;

  &[type='checkbox'] {
    display: none;
  }

  &[type='checkbox'] + label {
    display: flex;
    border: 1px solid ${(props: any) => (props.disabled ? '#e4e4e4' : '#344f79')};
    width: 18px;
    height: 18px;
    position: relative;
    background: ${(props: any) => (props.disabled ? '#e4e4e4' : 'white')};
  }

  &[type='checkbox']:checked + label {
    background: ${(props: any) => (props.disabled ? '#e4e4e4' : '#344f79')};
  }
  
  &[type='checkbox']:checked + label:after {
    content: '✔';
    color: ${(props: any) => (props.disabled ? '#6b6b6b' : 'white')};
    margin-top: -4px;
    margin-left: 2px;
  }
`;


export const StyledInputCheckbox = styled.input<any>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  flex: 1 0 auto;
  background: ${props =>
    props.disabled ? props.theme.bg.wash : props.theme.bg.default};
  font-weight: 400;
  font-size: 16px;
  border: 1px solid
    ${props =>
    props.disabled
      ? props.theme.bg.border
      : props.isAsyncMode
        ? '#d7d7d7'
        : props.theme.bg.inactive};
  border-radius: 10px;
  padding: 18px 12px;
  box-shadow: none;
  transition: border 300ms ease-in-out;
  &::disabled {
    opacity: 0.8;
  }
  &::-webkit-input-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:-moz-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:-ms-input-placeholder {
    color: ${props => props.theme.text.placeholder};
  }
  &:focus {
    border-color: ${props =>
    props.isAsyncMode ? '#44a5ff' : props.theme.brand.default};
    outline: none;
  }
  
  &[type='file'] {
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: hidden;
  }

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;


  &[type='checkbox'] + label {
    display: flex;
    border: 1px solid ${(props: any) => (props.disabled ? '#e4e4e4' : '#344f79')};
    width: 18px;
    height: 18px;
    position: relative;
    background: ${(props: any) => (props.disabled ? '#e4e4e4' : 'white')};
  }

  &[type='checkbox']:checked + label {
    background: ${(props: any) => (props.disabled ? '#e4e4e4' : '#344f79')};
  }
  
  &[type='checkbox']:checked + label:after {
    content: '✔';
    color: ${(props: any) => (props.disabled ? '#6b6b6b' : 'white')};
    margin-top: -4px;
    margin-left: 2px;
  }
`;

export const Input = (props: any) => {
  if (props.type && props.type === 'checkbox') {
    return <InputCheckbox {...props} />;
  }

  return (
    <Flex flex={1} style={props.containerStyle}>
      <StyledInput
        {...props.field}
        {...props}
        ref={props.subref}
        onKeyDown={({ key }: { key: string }) => {
          if (key === 'Enter' && props.form && !props.multiline && !!props.form.isValid) {
            try {
              props.form.submitForm();
            } catch (error) { }
          }
          // key === 'Enter' ? props.form.submitForm() : null
        }}
      />
    </Flex>
  );
};

export const InputFake = (props: any) => {
  if (props.type && props.type === 'checkbox') {
    return <InputCheckbox {...props} />;
  }

  return (
    <Flex flex={1} style={props.containerStyle}>
      <StyledInputFake
        {...props.field}
        {...props}
        ref={props.subref}
      >
        <Text style={{ opacity: !props.placeholder ? 0 : 0.5 }}>{props.placeholder || 'no placeholder'}</Text>
      </StyledInputFake>
    </Flex>
  );
};

export const InputFakeViewer = (props: any) => {
  if (props.type && props.type === 'checkbox') {
    return <InputCheckbox {...props} />;
  }

  return (
    <Flex flex={1} style={props.containerStyle}>
      <StyledInputFake
        {...props.field}
        {...props}
        ref={props.subref}
      >
        {props.value && (
          <Text >{props.value}</Text>
        )}
      </StyledInputFake>
    </Flex>
  );
};

export const InputCheckbox = (props: any) => {
  return (
    <div>
      <StyledInput
        {...props.field}
        {...props}
        onKeyDown={({ key }: { key: string }) => {
          if (key === 'Enter' && props.form && !!props.form.isValid) {
            try {
              props.form.submitForm();
            } catch (error) { }
          }
          // key === 'Enter' ? props.form.submitForm() : null
        }}
      />
      {props.id && props.type && props.type === 'checkbox' ? (
        <label htmlFor={props.id} />
      ) : null}
    </div>
  );
};

export const InputNoForm = (props: any) => {
  return (
    <div style={props.containerStyle}>
      <StyledInput
        {...props.field}
        {...props}
        ref={props.inputRef}
        onKeyDown={({ key }: { key: string }) => {
          if (key === 'Enter' && props.onReturn) {
            try {
              props.onReturn();
            } catch (error) { }
          }
          // key === 'Enter' ? props.form.submitForm() : null
        }}
      />
      {props && props.id && props.type && props.type === 'checkbox' ? (
        <label htmlFor={props.id} />
      ) : null}
    </div>
  );
}

export const InputWithLabel = (props: any) => {
  const [value, setValue] = useState(props.value || (props.field || {} as any).value);

  function handleChange(e: any) {
    setValue(e.target.value);
    if (props.onChange) {
      props.onChange(e)
    }
    if ((props.field || {} as any).onChange) {
      (props.field || {} as any).onChange(e)
    }
  }

  return (
    <InputContainer isDisabled={props.disabled}>
      <StyledInput
        {...props.field}
        {...props}
        placeholder=''
        ref={props.subref}
        onChange={handleChange}
        onKeyDown={({ key }: { key: string }) => {
          if (key === 'Enter' && props.form && !props.multiline && !!props.form.isValid) {
            try {
              props.form.submitForm();
            } catch (error) { }
          }
          // key === 'Enter' ? props.form.submitForm() : null
        }}
      />
      {props && props.id && (

        <label className={!!value ? 'filled' : ''} htmlFor={props.id}>
          {props.placeholder}
        </label>
      )}
    </InputContainer>
  );
};

export const TextAreaWithLabel = (props: any) => {
  const [value, setValue] = useState(props.value || (props.field || {}).value);

  function handleChange(e: any) {
    setValue(e.target.value);
    if (props.onChange) {
      props.onChange(e);
    }
    if ((props.field || {}).onChange) {
      (props.field || {}).onChange(e);
    }
  }

  return (
    <InputContainer isDisabled={props.disabled}>
      <StyledInputArea
        {...props.field}
        {...props}
        className={!!value || value === 0 ? 'filled2' : ''}
        placeholder=""
        ref={props.subref}
        onChange={handleChange}
        onKeyDown={({ key }) => {
          if (key === 'Enter' && props.form && !props.multiline && !!props.form.isValid) {
            try {
              props.form.submitForm();
            } catch (error) { }
          }
          // key === 'Enter' ? props.form.submitForm() : null
        }}
      />
      {props && props.id && (
        <label className={!!value || value === 0 ? 'filled' : ''} htmlFor={props.id}>
          {props.placeholder}
        </label>
      )}
    </InputContainer>
  );
};

export const TextInput = (props: any) => {
  return <Field {...props} component={Input} />;
};

export const TextInputWithLabel = (props: any) => {
  return <Field {...props} component={InputWithLabel} />;
};

export default TextInput;
